import { cn } from '@/lib/utils';

export function faqBlockStyles(className?: string) {
    return cn('w-full max-w-3xl mx-auto', className);
}

export function faqItemButtonStyles() {
    return cn(
        'flex w-full items-center justify-between gap-4 text-left',
        'py-2 text-lg font-medium text-foreground',
        'hover:text-primary transition-colors',
    );
}
